module.exports = __webpack_public_path__ + "media/images/touch-icon-d19775ddbb3513690e7a2420dd015084.png";